import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";

export default styled(Grid.Box)`
  ${({ theme }) => css`
    margin: ${theme.spacing.margins.md} 0;
  `}
`;
